export enum ApplicationEventType {
  CustomerCreated = 1,
  UserCreated = 2,
  UserUpdated = 3,
  BoxAdded = 4,
  PentestConfigCreated = 5,
}

export namespace ApplicationEventType {
  export function mapFromApiValue(applicationEventType: string): ApplicationEventType {
    const types: Record<string, ApplicationEventType> = {
      ['CUSTOMER_CREATED']: ApplicationEventType.CustomerCreated,
      ['USER_CREATED']: ApplicationEventType.UserCreated,
      ['USER_UPDATED']: ApplicationEventType.UserUpdated,
      ['BOX_ADDED']: ApplicationEventType.BoxAdded,
      ['PENTEST_CONFIG_CREATED']: ApplicationEventType.PentestConfigCreated,
    };
    return types[applicationEventType];
  }

  export function name(applicationEventType: ApplicationEventType): string {
    const types: Record<ApplicationEventType, string> = {
      [ApplicationEventType.CustomerCreated]: 'partners.eventTypes.customerCreated',
      [ApplicationEventType.UserCreated]: 'partners.eventTypes.userCreated',
      [ApplicationEventType.UserUpdated]: 'partners.eventTypes.userUpdated',
      [ApplicationEventType.BoxAdded]: 'partners.eventTypes.boxAdded',
      [ApplicationEventType.PentestConfigCreated]: 'partners.eventTypes.pentestConfigCreated',
    };

    return types[applicationEventType];
  }
}
